<button mat-menu-item [matTooltip]="!isAvailable ? ('navigation.status.offline_tooltip' | translate) : ''" matTooltipPosition="above">
  <div class="status">
    <span class="status-dot" [class.green]="isAvailable" [class.orange]="!isAvailable"></span>
    <span>{{ (isAvailable ? 'navigation.status.online' : 'navigation.status.offline') | translate }}</span>
  </div>
</button>
